import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
  }> {}

export const PartnerPickDevicesEditPage: FunctionComponent<Props> = () => (
  <Fragment>
    <DocumentTitle titleId="TODO" />

    <div>PartnerPickDevicesEditPage</div>
  </Fragment>
)
